function CommaSeparator(num) {
  return num?.toLocaleString();
}
export default CommaSeparator;
